export default function determinePercentualTheme(value: number){
    if(value === 100) return '#4caf50'
    if(value >= 50) return '#ff9800'
    return '#f44336'
}